import React from 'react'
import { useNavigate } from 'react-router-dom'

const MapBroadcastManager = () => {
  const navigate = useNavigate()

  React.useEffect(() => {
    const bc = new BroadcastChannel('map-channel')

    bc.onmessage = (event) => {
      const type = event.data?.type

      if (type === 'MAP_PIN_CLICK') {
        navigate(`/device/${event.data.deviceId}`)
      }
    }

    return () => {
      bc.close()
    }
  }, [])

  return null
}

export default MapBroadcastManager
